module.exports = __webpack_public_path__ + "img/map_containers_active.0c9039f9.svg";